import React from 'react';
import { TextField } from '@mui/material';
import i18n from '../../i18n';


export default class DialogCryptoAmountField extends React.Component {

    onChange(event) {
        this.props.onChange(
            this.props.field.id,
            event.target.value
        );
    }

    render() {
        return (
            <TextField
                key={this.props.field.id}
                id={this.props.field.id}
                label={i18n.t(`columns.${this.props.field.label}`)}
                placeholder="0.000000"
                value={this.props.value}
                fullWidth
                onChange={(event) => this.onChange(event)}
            />
        );
    }
}
